import { render, staticRenderFns } from "./CollectorSelectDialog.vue?vue&type=template&id=bf16f170&scoped=true&"
import script from "./CollectorSelectDialog.vue?vue&type=script&lang=js&"
export * from "./CollectorSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./CollectorSelectDialog.vue?vue&type=style&index=0&id=bf16f170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf16f170",
  null
  
)

export default component.exports